var Css = {
  jsonTd: {
  },
  rootElement: {
  },
  subElement: {
  },
  indent: {
  },
  dataCell: {
  },
  jsonTable: {
  }
}

export default Css;
